<template>
    <card-grid
        ref="arrivalsGrid"
        :button-toolbar-class="[]"
        :is-search="false"
        :key="cardGridKey"
        :pagination="true"
        :fetchCallback="fetchCallback"
        :columnDefs="columnDefs"
        :pagination-page-size="limit"
        :cache-block-size="limit"
        :is-auto-width="true"
        :font-size="tabWidget.settings.table_font_size"
    >
    </card-grid>
</template>

<script>
import API from '../../../../api'
import CardGrid from '../../../generic/card-grid/card-grid.vue'
import GuestCellRenderer from './guest-cell-renderer.vue'
import CheckInCellRenderer from './check-in-cell-renderer.vue'
import ActionsCellRenderer from './actions-cell-renderer.vue'
import StateMarkerCellRenderer from './state-marker-cell-renderer.vue'
import { renderReservationIdColumn } from '../helpers'
import { mapGetters } from 'vuex'

export default {
    name: 'ArrivalsCardGrid',
    components: {
        CardGrid,
        guestCellRenderer: GuestCellRenderer,
        checkInCellRenderer: CheckInCellRenderer,
        actionsCellRenderer: ActionsCellRenderer,
        stateMarkerCellRenderer: StateMarkerCellRenderer,
    },
    props: {
        getDataEndpoint: {
            type: String,
            required: true,
        },
        getDataParams: Object,
        tabWidget: Object,
        cardGridKey: Number,
        limit: Number,
    },
    data() {
        return {
            offset: 0,
            sort: 'id',
            desc: false,
            search: '',
        };
    },
    computed: {
        ...mapGetters('dashboard', ['refreshedWidgetSysname']),
        columnDefs() {
            return [
                {
                    field: 'reservation.state.sysname',
                    headerName: '',
                    maxWidth: 60,
                    sortable: false,
                    cellRenderer: 'stateMarkerCellRenderer',
                },
                {
                    field: 'reservation.guest_name',
                    headerName: 'Guest',
                    headerClass: 'guest-name-status-column',
                    minWidth: 200,
                    cellRenderer: 'guestCellRenderer',
                    cellRendererParams: {
                        getReservation({ data }) {
                            return data.reservation;
                        },
                    },
                    autoWidthExclude: true
                },
                {
                    field: 'reservation.id',
                    headerName: 'Invoice #',
                    maxWidth: 120,
                    minWidth: 120,
                    cellRenderer: ({ data }) => renderReservationIdColumn(data),
                },
                {
                    field: 'property_name',
                    headerName: 'Property',
                    minWidth: 200,
                    autoWidthExclude: true
                },
                {
                    field: 'from_date',
                    headerName: 'Date',
                    minWidth: 130,
                    type: 'dateColumn',
                    sort: 'asc',
                },
                {
                    field: 'check_in',
                    headerName: 'Hour',
                    minWidth: 130,
                    sortable: false,
                    cellRenderer: 'checkInCellRenderer'
                },
                {
                    field: '',
                    headerName: '',
                    minWidth: 150,
                    sortable: false,
                    cellClass: 'arrivals-actions',
                    cellRenderer: 'actionsCellRenderer',
                    cellRendererParams: {
                        update: () => {
                            this.refreshGrid()
                            this.$store.commit('dashboard/setRefreshedWidgetSysname', this.tabWidget.widget.sysname)
                        },
                    },
                }
            ];
        },
        fetchCallback() {
            return ({ offset, sort, desc }) => {
                this.offset = offset;
                this.sort = sort;
                this.desc = desc;
                return API.get(this.getDataEndpoint, {
                    params: {
                        ...this.getDataParams,
                        limit: this.limit,
                        offset: this.offset,
                        desc: this.desc,
                        sort: this.sort,
                        with_blocked:
                            this.tabWidget.settings
                                .display_blocked_reservations,
                    },
                });
            };
        },
    },
    methods: {
        refreshGrid() {
            this.$refs.arrivalsGrid.$children[0].refreshDataSource();
        }
    },
    watch: {
        refreshedWidgetSysname(newVal) {
            if (newVal && newVal !== this.tabWidget.widget.sysname) {
                this.refreshGrid()
                this.$store.commit('dashboard/setRefreshedWidgetSysname', '')
            }
        }
    }
}
</script>

<style lang="scss">
.arrivals-actions {
    display: flex;
    justify-content: center !important;
}
</style>
